const MOBILE_PREVIEW_QUERY = "(max-width: 991px)";
export function shouldUseReplitMobilePreview(hostname, isMobileViewport, search = "") {
    if (!/\.replit\.dev$/i.test(hostname)) {
        return false;
    }
    const forcePwaPreview = new URLSearchParams(search).get("pwa-preview") === "1";
    return isMobileViewport || forcePwaPreview;
}
export function shouldUseInjectedMetaMaskPreview(hostname, search, isEmbedded) {
    return (/\.replit\.dev$/i.test(hostname) &&
        (isEmbedded ||
            new URLSearchParams(search).get("pwa-preview") === "1"));
}
export function getReplitMobilePreviewSnapshot() {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
        return false;
    }
    return shouldUseReplitMobilePreview(window.location.hostname, window.matchMedia(MOBILE_PREVIEW_QUERY).matches, window.location.search);
}
export function subscribeToReplitMobilePreview(onStoreChange) {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
        return () => undefined;
    }
    const mediaQuery = window.matchMedia(MOBILE_PREVIEW_QUERY);
    mediaQuery.addEventListener("change", onStoreChange);
    return () => mediaQuery.removeEventListener("change", onStoreChange);
}
